import { useMemo } from 'react';
import { getBalancePrice, displayAmount } from '@/utils/token';
import { useTokenPrice } from './useTokenPrice';
import { useToken } from './useToken';

export function useTokenAmountPrice(tokenId: string, amount: string) {
  const token = useToken(tokenId);
  const { value: tokenPrice } = useTokenPrice(tokenId);

  const value = useMemo(() => {
    if (typeof tokenPrice !== 'string') {
      return tokenPrice;
    }

    if (!amount || !token) {
      return '0';
    }

    return getBalancePrice({
      token: { price: tokenPrice, decimals: token.decimals },
      amount,
    });
  }, [tokenPrice, amount, token]);

  const formatted = useMemo(() => {
    if (typeof value !== 'string') {
      return undefined;
    }

    return displayAmount(value);
  }, [value]);

  return {
    value,
    formatted,
  };
}
